// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"420":"eff05126","445":"b24d6e0a","993":"12fe3f7f"}[chunkId] + ".css";
};